const constantRouters = [
  {
    path: '/',
    redirect: '/download',
    component: () => import('@/Layout'),
    children: [
      {
        path: '/download',
        component: () => import('@/views/Home'),
        meta: {
          title: '下载WhatsApp SCRM客户端'
        }
      }
    ]
  },
  {
    path: '/bulk-send-share',
    component: () => import('@/views/BulkSend'),
    meta: {
      title: 'bulk-send-share'
    }
  },
  {
    path: '*',
    component: () => import('@/views/Exception')
  }
]

export { constantRouters }
